import { gql } from "@apollo/client";

export const UPDATE_PRODUCT = gql`
  mutation UpdateProduct(
    $data: ProductUpdateInput!
    $where: ProductWhereUniqueInput!
  ) {
    updateProduct(data: $data, where: $where) {
      id
      itemPreferences
    }
  }
`;

export const APPLY_PRODUCT_HAS_INDIVIDUAL_CHARACTERISTICS = gql`
  mutation ApplyProductHasIndividualCaracteristics(
    $productId: String!
    $itemsHaveIndividualCaracteristics: Boolean!
  ) {
    applyProductHasIndividualCaracteristics(
      productId: $productId
      itemsHaveIndividualCaracteristics: $itemsHaveIndividualCaracteristics
    ) {
      id
    }
  }
`;

export const DELETE_MANY_PRODUCTS = gql`
  mutation DeleteManyProduct($where: ProductWhereInput) {
    deleteManyProduct(where: $where)
  }
`;
